import _ from 'lodash';
import React from 'react';
import { injectIntl } from 'react-intl';
import ChartPeriod from './ChartPeriod';
import SingleToggle from './SingleToggle';
class ChartPeriodSelector extends React.Component {
  constructor(props) {
    super(props);
    this.addPeriod = this.addPeriod.bind(this);
  }

  addPeriod(type) {
    this.props.addPeriod(type);
  }

  localize(i18nKey, otherParams) {
    return this.props.intl.formatMessage({ id: i18nKey }, otherParams);
  }

  getPeriods(type) {
    let indicator =
      _.find(this.props.indicators, indicator => indicator.type === type) || {};
    return indicator.params || [];
  }

  toggleIndicator = event => {
    let value = event.target.checked;
    if (value) {
      this.props.addIndicator(this.props.type);
    } else {
      this.props.deleteIndicator(this.props.type);
    }
  };

  render() {
    let periods = this.props.isIndicatorActive(this.props.type) ? (
      <div className="settings-chart-indicators-container">
        <div className="settings-chart-indicators-properties">
          {this.getPeriods(this.props.type).map((period, i) => {
            return (
              <ChartPeriod
                {...this.props}
                key={i}
                id={i}
                period={period}
                setPeriod={this.props.setPeriod}
                deletePeriod={this.props.deletePeriod}
              />
            );
          })}
        </div>
      </div>
    ) : null;

    return (
      <div className="">
        <div className="settings-card-contents">
          <SingleToggle
            title={this.localize(
              'settings.chart.indicators.' + this.props.type + '.title'
            )}
            checked={this.getPeriods(this.props.type).length > 0}
            onChange={this.toggleIndicator}
            skipList={true}
            toggleFavorite={this.props.toggleFavorite}
            type={this.props.type}
            isFavorite={this.props.isFavorite}
          />
        </div>
        {periods}
      </div>
    );
  }
}

export default injectIntl(ChartPeriodSelector);
